module.exports = __webpack_public_path__ + "static/media/agent.30fc510a.svg";